<!--
    EiToolingStageVisualizerCompactComponent Template

    Horizontal stepper of all 7 pipeline phases with color-coded
    circles and connector lines.
-->

<div class="flex align-items-center gap-1 overflow-x-auto">
    @for (phase of allPhases; let i = $index; track phase.key) {
        <div class="flex align-items-center">
            <div
                    [class]="phaseCircleClass(phase)"
                    [style.backgroundColor]="phaseCircleBackground(phase)"
                    [pTooltip]="phaseTooltip(phase)"
                    tooltipPosition="top">
                <i [class]="phase.icon"></i>
            </div>
            @if (i < allPhases.length - 1) {
                <div class="ei-phase-connector"
                     [style.backgroundColor]="connectorColor(phase)"></div>
            }
        </div>
    }
</div>
